import React from 'react'
import { ReactElement } from 'react'

import Checkbox from '../../../../../../../../1stlog-ui/src/components/Checkbox'
import Field from '../../../../../../../../1stlog-ui/src/components/Field'

const Preference = (): ReactElement => {
  return (
    <div className="mt-1 mr-n2">
      <Field hideLabel label="preference" name="preferenceCode">
        <Checkbox
          tooltip={i18n.t(
            'customs_preference_tooltip',
            'Die Einfuhr zum Präferenzzollsatz wird nur dann gewährt, wenn die eingeführte Ware ein Ursprungserzeugnis im Sinne des jeweiligen Präferenzabkommens ist. Dies ist grundsätzlich dann der Fall, wenn die Ware im Gebiet der jeweiligen Vertragspartei vollständig gewonnen oder hergestellt ist (z. B. in dem Land geborene und gezüchtete Tiere, dort geerntetes Gemüse etc.). Allerdings kann es sich auch um eine präferenzielle Ursprungsware handeln, wenn die Ware in ausreichendem Maße im Gebiet der Vertragspartei be- oder verarbeitet worden ist. Der Nachweis des Präferenzursprungs hat grundsätzlich durch entsprechende Dokumente zu erfolgen.',
          )}
        >
          {i18n.t('customs_preference', 'Präferenzzollsatz')}
        </Checkbox>
      </Field>
    </div>
  )
}

export default Preference
